var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
import { forwardRef } from "react";
const SvgUserEditIcon = (_ref, ref) => {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 26,
    height: 26,
    viewBox: "0 0 26 26",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: ref,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Group 30"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector",
    d: "M9.30765 9.30769C11.6018 9.30769 13.4615 7.44795 13.4615 5.15385C13.4615 2.85974 11.6018 1 9.30765 1C7.01355 1 5.15381 2.85974 5.15381 5.15385C5.15381 7.44795 7.01355 9.30769 9.30765 9.30769Z",
    stroke: "currentColor",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_2",
    d: "M6.53846 23.1539H1V20.3846C1.0147 18.9775 1.3858 17.597 2.07866 16.3722C2.77151 15.1473 3.76351 14.1181 4.96198 13.3806C6.16046 12.643 7.52631 12.2213 8.93197 12.1548C10.3376 12.0882 11.7372 12.379 13 13",
    stroke: "currentColor",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_3",
    d: "M25.0003 15.7692L16.3049 24.4646L12.3726 24.9999L12.9264 21.0676L21.6033 12.3723L25.0003 15.7692Z",
    stroke: "currentColor",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })))));
};
const ForwardRef = /*#__PURE__*/forwardRef(SvgUserEditIcon);
export { ForwardRef as ReactComponent };
export default __webpack_public_path__ + "static/media/user_edit_icon.da3d77a98d3bdd2bcf8f1c11214d62fa.svg";